import React, { forwardRef, useCallback } from 'react'

import { E164Number } from 'libphonenumber-js/core'
import phone from 'phone'
import PhoneNumberInput, { Props as PhoneNumberInputProps, State } from 'react-phone-number-input'

type Props = PhoneNumberInputProps<Partial<HTMLInputElement>>
type PhoneInputRef = React.Component<Props, State<Props>, unknown>

const PhoneInput = forwardRef<PhoneInputRef, Props>(({ onChange, ...props }, ref) => {
  const handleChange = useCallback(
    (value: E164Number) => {
      const { phoneNumber } = phone(value)
      onChange((phoneNumber as E164Number) || value)
    },
    [onChange],
  )

  return <PhoneNumberInput ref={ref} type="tel" onChange={handleChange} {...props} />
})

PhoneInput.displayName = 'PhoneInput'

export default PhoneInput
